export type SafeErrorTelemetryContext = Record<string, string | undefined>;

type ErrorTelemetrySender = (message: Error | string, context?: SafeErrorTelemetryContext) => void;

let errorTelemetrySender: ErrorTelemetrySender | null = null;

/** Регистрируется один раз в main.ts после инициализации production Hawk. */
export const setErrorTelemetrySender = (sender: ErrorTelemetrySender): void => {
  errorTelemetrySender = sender;
};

/**
 * Ручная отправка только ожидаемо безопасного сообщения и whitelist-контекста.
 * Исходный network/GraphQL error намеренно не передаётся: он может содержать
 * variables с финансовым payload или PII.
 */
export const captureUnexpectedError = (message: string, context: SafeErrorTelemetryContext): void => {
  errorTelemetrySender?.(new Error(message), context);
};
